import type { FaireProductEntity } from "../../entity_types/product";

export const p_qkbxk7hse3: FaireProductEntity = {
  token: "p_qkbxk7hse3",
  type: "product",
  name: "Super Spa Set | Coral, Self-Care, Easter, Mother's Day",
  brandToken: "b_197fd05f",
  brandName: "Pinch Provisions",
  imageUrl:
    "https://cdn.faire.com/fastly/82cb07e204c972589eb40b1a0d8809add1944c40311f1c918db0fdbfe274ff7f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1256a29afe562f0b11d6a34486d8fbf747fac5443b549f280d245c7374f55def.jpeg",
    "https://cdn.faire.com/fastly/cdb5d22bd5315aa502baefde96f71b2ac6b149e8879f65e41b6ec0b44760de3e.jpeg",
    "https://cdn.faire.com/fastly/936d673ffef92b3a63875c1c503a52c9f31a705f3c6f768de26ccbc1ae40559d.png",
  ],
  priceDollars: 27.39,
  description:
    "The Super Spa Set by Pinch Provisions features an abstract coral pattern in a soft, feminine palette. Not too pink, not too peach, this bestselling coral set will thrive in any wellness assortment. Thoughtfully packed in a nostalgic ivory jelly tote with a coordinating drawstring bag and scarf twill, this deluxe set is a ready-to-gift “self-carryall” your customers will love to give (and get).\n\nEach set includes 8 premium spa essentials for the ultimate at-home pampering session: full-size ivory ice roller, silky coordinating sleep mask, gua sha, exfoliating mitt, acetate hair clip, lavender shower steamer, scalp massager, and silky coordinating scrunchie.\n\nWith eye-catching packaging and high perceived value, this kit is a standout for beauty assortments as well as fall and holiday gifting displays.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 54.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:48.572Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
